var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIInbox({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.375 26.3201L44.366 52.9201C43.7248 53.4918 42.8958 53.8077 42.0367 53.8077C41.1777 53.8077 40.3487 53.4918 39.7075 52.9201L9.4605 26.4601C9.6845 26.2676 9.919 26.0926 10.171 25.9281L36.2565 8.87612C37.9642 7.76026 39.96 7.16602 42 7.16602C44.04 7.16602 46.0358 7.76026 47.7435 8.87612L73.829 25.9281C74.018 26.0506 74.2 26.1836 74.375 26.3236V26.3201ZM77 33.9151V70.0001C77 71.8566 76.2625 73.6371 74.9497 74.9499C73.637 76.2626 71.8565 77.0001 70 77.0001H14C12.1435 77.0001 10.363 76.2626 9.05025 74.9499C7.7375 73.6371 7 71.8566 7 70.0001V33.9431L35.049 58.1491C36.9723 59.8632 39.4587 60.8104 42.035 60.8104C44.6113 60.8104 47.0977 59.8632 49.021 58.1491L77 33.9151Z",
    fill: "#119480"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIInbox);
export default __webpack_public_path__ + "static/media/i__inbox.5cde0e687347c5578f0bb1fa654b5967.svg";
export { ForwardRef as ReactComponent };